import 'select2';
import Pagination from '../modules/pagination/pagination';

class ReportSection {
    constructor(el) {
        if (!this.set(el)) return;
        this.init();
    }

    set(el) {
        if (!el) return false;

        this.root = el;
        this.selects = this.root.querySelectorAll('select');
        this.formEl = this.root.querySelector('.reports-section__form');
        this.htmlWrapper = this.root.querySelector(
            '.reports-section__reports-wrapper'
        );
        this.form = this.root.querySelector('form');
        this.paginationWrapper = this.root.querySelector('.pagination');
        this.loaderWrapper = this.root.querySelector(
            '.reports-section__loader-wrapper'
        );
        this.year = '';
        this.month = '';
        this.phrase = null;
        this.page = 1;
        this.postType = this.root.getAttribute('data-post-type');

        this.selectInstances = [];
        this.paginationInstance = null;

        return true;
    }

    init() {
        this.setSelectInstances();
        this.handleSelectListener();
        this.handlePaginationInstance();
        this.handleFormSubmit();
    }

    setSelectInstances() {
        if (this.selects.length === 0) return false;

        this.selects.forEach(select => {
            const settings = JSON.parse(select.getAttribute('data-settings'));
            settings['width'] = '100%';
            settings['dropdownCssClass'] = 'no-search';
            this.selectInstances.push($(select).select2(settings));
        });
    }

    handleSelectListener() {
        if (this.selectInstances.length === 0) return false;
        const that = this;
        this.selectInstances.forEach(instance => {
            instance.on('select2:select', function (e) {
                const selectedIndex = this.selectedIndex;
                const val = this.options[selectedIndex].value;
                if (this.getAttribute('name') === 'year') {
                    that.year = selectedIndex === 0 ? '' : val;
                } else {
                    that.month = selectedIndex === 0 ? '' : val;
                }
                this.page = 1;
                that.handleFetch();
            });
        });
    }

    handlePaginationInstance() {
        if (!this.paginationWrapper) return false;
        this.paginationInstance = new Pagination(
            this.paginationWrapper,
            this.root
        );

        this.root.addEventListener('pagination-change', e => {
            const { detail } = e;
            this.page = detail;
            this.handleFetch();

            if (this.formEl) {
                this.formEl.scrollIntoView({ behavior: 'smooth' });
            }
        });
    }

    handleFormSubmit() {
        if (!this.form) return false;

        this.form.addEventListener('submit', e => {
            e.preventDefault();
            this.page = 1;
            this.handleFetch();
        });
    }

    async handleFetch() {
        this.loaderWrapper.classList.add('active');
        const formData = new FormData();
        this.phrase = this.form.querySelector("[name='phrase']").value;
        formData.append('action', 'handle_report_fetch');
        formData.append('year', this.year);
        formData.append('month', this.month);
        formData.append('phrase', this.phrase);
        formData.append('page', this.page);
        formData.append('postType', this.postType);
        try {
            const req = await fetch(ajax.url, {
                method: 'POST',
                body: formData,
            });

            if (!req) return;

            const { html, page, max_num_pages } = await req.json();

            if (html?.length > 0) {
                this.htmlWrapper.innerHTML = html;

                this.paginationInstance.reset(page, parseInt(max_num_pages));
            }
        } catch (error) {
            console.log(`error: ${error}`);
        } finally {
            this.loaderWrapper.classList.remove('active');
        }
    }
}

const sections = document.querySelectorAll('.reports-section');
const initReportsSections = sections => {
    if (sections) {
        sections.forEach(section => new ReportSection(section));
    }
};

initReportsSections(sections);
